import { useMemo, useState } from "react";
import { useQuery, useMutation } from "convex/react";
//import { api } from "../../convex/_generated/api";
import { useParams } from "react-router-dom";
//import Loader from "../components/Loader";
import {api} from "./convex/_generated/api"


const CATEGORY_ORDER = [
  "Produce",
  "Dairy",
  "Meat",
  "Pantry",
  "Other",
];


export default function GroceryList(){

  const { userId } = useParams();
  const [quantities, setQuantities] = useState({});


  // pantry source
  const pantry = useQuery(
  api.pantry.getPantry,
  userId
    ? { userId }
    : "skip"
) || [];
//const pantry = useQuery(api.pantry.getPantry);


  // selected grocery items
  const grocery = useQuery(
  api.grocery.getGroceryList,
  userId
    ? { userId }
    : "skip"
) || [];

 console.log(grocery);


  const addToGrocery = useMutation(
    api.grocery.addToGrocery
  );


  const removeFromGrocery = useMutation(
    api.grocery.removeFromGrocery
  );

  const updateGroceryTotal = useMutation(
  api.grocery.updateGroceryTotal
);

const removeGroceryTotal = useMutation(
  api.grocery.removeGroceryTotal
);

const groceryTotal = useQuery(
  api.grocery.getGroceryTotal,
  userId
    ? { userId }
    : "skip"
);


  const [copied,setCopied] = useState(false);



  const grouped = useMemo(()=>{

    const groups={};


    pantry?.forEach(item=>{

      const category =
        item.category || "Other";


      if(!groups[category])
        groups[category]=[];


      groups[category].push(item);

    });


    return groups;


  },[pantry]);



  const groceryIds =
    grocery?.map(
      item=>item.pantryId
    ) || [];




  async function toggleGrocery(item){


    const exists =
      groceryIds.includes(
        item._id
      );


    if(exists){

      await removeFromGrocery({
        pantryId:item._id,
        userId
      });

   await removeGroceryTotal({
  userId,
  ingredient: item.ingredient,
  quantity: quantities[item._id] || 1,
  unitCost: item.cost,
});


    }
    else{


      await addToGrocery({
  pantryId: item._id,
  userId,

  ingredient: item.ingredient,
  category: item.category,
  cost: item.cost,
  quantity: quantities[item._id] || 1,
});


await updateGroceryTotal({
  userId,
  ingredient: item.ingredient,
  quantity: quantities[item._id] || 1,
  unitCost: item.cost,
});

    }

  }





  function copyLink(){

    navigator.clipboard.writeText(
      `${window.location.origin}/grocery/share/${userId}`
    );


    setCopied(true);


    setTimeout(
      ()=>setCopied(false),
      2000
    );

  }





  //if(
    //pantry === undefined ||
    //grocery === undefined
  //){

    //return <Loader/>;

  //}



  return (

    <div className="screen">


      <div className="eyebrow">
        Shopping
      </div>


      <h1 className="page-title">
        Grocery List
      </h1>



      <p className="subtitle">
        Select pantry items to add to your shopping list
      </p>





      {
        CATEGORY_ORDER
        .filter(
          c=>grouped[c]?.length
        )
        .map(category=>(


        <div key={category}>


          <div className="category-header">
            {category}
          </div>




          {
            grouped[category || []].map(item=>{


              const added =
                groceryIds.includes(
                  item._id
                );



              return (

              <div
                key={item._id}
                className="grocery-row"
                onClick={()=>
                  toggleGrocery(item)
                }
              >


                <span
                  className={`checkbox ${
                    added
                    ?
                    "checked"
                    :
                    ""
                  }`}
                >

                  {
                    added
                    ?
                    "✓"
                    :
                    ""
                  }

                </span>



                <span className="name">
                  {item.ingredient}
                </span>



                <span className="cost">
                  ${item.cost.toFixed(2)}
                </span>

                
                <input
                type="number"
                min="1"
                //onClick={(e) => e.stopPropagation()}
                value={quantities[item._id] || 1}
                onChange={(e) =>
                  setQuantities({
                    ...quantities,
                    [item._id]: Number(e.target.value)
                  })
                }
              />


              </div>

              );

            })
          }



        </div>
  


        ))
      }

      <h3 className="category-header" style={{ marginTop: 30 }}>
  Grocery List
</h3>

<div className="ingredient-grid">

  {grocery.map((item) => (

    <div
      key={item._id}
      className="grocery-row"
    >

      <span className="name">
        {item.ingredient}
      </span>

      <span>
        Qty: {item.quantity}
      </span>

      <span className="cost">
        ${item.totalCost.toFixed(2)}
      </span>

    </div>

  ))}

</div>

      <div className="stat-box">
        <div className="stat-value">
  ${
    grocery.reduce(
      (sum, item) => sum + item.totalCost,
      0
    ).toFixed(2)
  }
</div>

        <div className="stat-label">
          Estimated Total
        </div>
      </div>




      <button
        className="btn btn-secondary"
        style={{
          marginTop:20
        }}
        onClick={copyLink}
      >

        {
          copied
          ?
          "Link copied!"
          :
          "Share Grocery List"
        }

      </button>


    </div>

  );


}